import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

export const GetAllTemplateSettings = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.ResultFilePreConfiguration.GetTemplateSettings}`,
    queryModel
  );
};

export const SaveCells = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.ResultFilePreConfiguration.SaveCells}`,
    queryModel
  );
};

export const AddTemplateSettings = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.PGXLis.ResultFilePreConfiguration.AddTemplateSettings}`,
    queryModel
  );
};

export const TranslatorLookupApi = () => {
  return HttpClient().get(
    `/${apiRoutes.PGXLis.ResultFilePreConfiguration.TranslatorLookup}`
  );
};

export const FileTemplateLookup = () => {
  return HttpClient().get(
    `/${apiRoutes.PGXLis.ResultFilePreConfiguration.FileTemplateLookup}`
  );
};
